export const APP_STORE_URL = 'https://apps.apple.com/us/app/avenu-social-event-discovery/id1487333983';

export const GENDERS = ["", "Male", "Female", "Non-binary", "Prefer not to say"];
export const STATUSES = ["GOING", "NOT SURE", "STAYING"];

export const TEMP_NEW_TICKET_SKU = "NEWTICKET0123456789876543210";
export const EVENT_NAME_LIMIT = 24; 
